import type { components } from '@/api/schema'

/**
 * Tipos de resposta gerados a partir de `artifacts/openapi/v1.json` (SS-02 anota `.Produces<T>()`).
 * Nunca redeclarar estes shapes a mao: `npm run api:types` e a unica fonte.
 */
export type WebsiteDiscovery = components['schemas']['WebsiteDiscoveryResponse']
export type WebsiteDiscoverySources = components['schemas']['WebsiteDiscoverySourcesResponse']
export type KnowledgeDocuments = components['schemas']['KnowledgeDocumentsResponse']
export type KnowledgeDocument = components['schemas']['KnowledgeDocumentResponse']
export type DocumentImport = components['schemas']['DocumentImportResponse']

/**
 * Visibilidade de um documento (`KnowledgeDocumentResponse.visibility`): `customer` = o agente pode
 * repetir ao cliente; `internal` = orienta o agente sem ser reproduzido. O OpenAPI tipa como `string`
 * solto; qualquer valor novo cai no fallback honesto de quem consome (tratado como `customer`).
 */
export type DocumentVisibilityValue = 'customer' | 'internal'

/**
 * Classificacao enviada no upload (campo opcional `classification` do multipart). Omitir = `Public`
 * (visivel ao cliente). `Internal` marca "uso interno" — o agente considera, mas nao repete ao cliente.
 */
export type DocumentClassification = 'Public' | 'Internal'

/**
 * O OpenAPI tipa `status` como `string` solto (o C# serializa o enum via `ToString()`). Os literais
 * abaixo espelham `Codout.Support.Domain.Knowledge.WebsiteDiscoveryJobStatus` + o estado sintetico
 * `NotStarted`; qualquer valor novo do backend cai no fallback honesto de quem consome.
 */
export type DiscoveryStatusValue =
  'NotStarted' | 'Queued' | 'Crawling' | 'Indexing' | 'Ready' | 'Failed'

/** Espelha `Codout.Support.Domain.Knowledge.KnowledgeDocumentStatus`. */
export type DocumentStatusValue = 'Pending' | 'Processing' | 'Ready' | 'Failed'

/**
 * Espelha `Codout.Support.Domain.Knowledge.DocumentImportJobStatus`: o ciclo do job durable de
 * importacao de um arquivo enviado. `Importing` = extraindo texto + indexando; qualquer valor novo
 * do backend cai no fallback honesto de quem consome.
 */
export type DocumentImportStatusValue = 'Queued' | 'Importing' | 'Ready' | 'Failed'

/** Coerce dos inteiros do OpenAPI (int32/int64 vem como `number | string`) para number. */
export function asNumber(value: number | string): number {
  return typeof value === 'number' ? value : Number(value)
}
